import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        parentSkill: '<',
        onClose: '&',
        onUpdate: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Add Child Skill' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <div class="alert alert-plain">
                    <p>{{ 'user.Adding child skill for the following parent skill:' | translate }} <strong>{{ vm.parentSkill.name }}</strong></p>
                </div>
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'user.Skill name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.description">
                        <label class="label">{{ 'user.Skill Description' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.description" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor ($translate, FormFactory, SkillResource, MomentService, ModalService) {
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.SkillResource = SkillResource;
        this.ModalService = ModalService;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(new this.SkillResource);
    }

    save () {
        this.form.model.parentSkillId = this.parentSkill.id;
        this.form.save().then(subSkill => {
            this.onUpdate({ subSkill });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/skill/addSub/index.js